import React from 'react';
import { Field } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { RenderGhostError } from 'components/shared/RenderError';
import { featureEnabled } from 'helpers/ToggleBot';

const nonDialogStyle = {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const dialogStyle = {
  textAlign: 'center',
};

const rowWithMinWidth = {
  marginBottom: '20px',
  minWidth: '300px',
};

const rowWithoutMinWidth = {
  marginBottom: '20px',
};

class AddDocumentOfProofs extends React.Component {
  render() {
    return (
      <div className="row" style={this.props.dialog ? dialogStyle : nonDialogStyle}>
        <div className="row" style={this.props.dialog ? rowWithoutMinWidth : rowWithMinWidth}>
          <h3>{getTranslatedString('landlordPortal.addDocumentOfProofs.proofOfIncome')}</h3>
          <div className="col-md-12">
            <Field
              name="incomeProofType"
              component={SelectField}
              floatingLabelText={getTranslatedString(
                'landlordPortal.addDocumentOfProofs.documentType'
              )}
              fullWidth
              style={{
                fontSize: '14px',
                textAlign: 'left',
              }}
              errorStyle={{ fontSize: '14px' }}
            >
              <MenuItem
                value={'Pay Stub'}
                primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.payStub')}
              />
              <MenuItem
                value={'Letter of Employment'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.letterOfEmployment'
                )}
              />
              <MenuItem
                value={'Bank Statement'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.bankStatement'
                )}
              />
              <MenuItem
                value={'Income Assistance'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.incomeAssistance'
                )}
              />
              <MenuItem
                value={'Seperation Maintenance'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.seperationMaintenance'
                )}
              />
              <MenuItem
                value={'Student Loans'}
                primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.studentLoans')}
              />
              <MenuItem
                value={'Other'}
                primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.other')}
              />
            </Field>
            <Field name={'incomeProofType'} component={RenderGhostError} />
          </div>
          <div className="col-md-12">
            <Field
              name="proofOfIncome"
              component={ReduxDropzone}
              style={{
                border: `1px dashed ${colors.LIGHT_GRAY}`,
                width: '40%',
                margin: 'auto',
                textAlign: 'center',
              }}
              fileValidation=".jpeg, .png, .jpg, application/pdf"
              size={100}
              labelText={getTranslatedString('landlordPortal.addDocumentOfProofs.clickToAddFile')}
            />
            <Field name={'proofOfIncome'} component={RenderGhostError} />
          </div>
        </div>
        <div className="row" style={this.props.dialog ? null : rowWithMinWidth}>
          <h3>{getTranslatedString('landlordPortal.addDocumentOfProofs.Identification')}</h3>
          <div className="col-md-12">
            <Field
              name="idProofType"
              component={SelectField}
              floatingLabelText={getTranslatedString(
                'landlordPortal.addDocumentOfProofs.documentType'
              )}
              fullWidth
              style={{
                fontSize: '14px',
                textAlign: 'left',
              }}
              errorStyle={{ fontSize: '14px' }}
            >
              <MenuItem
                value={'Citizenship Card'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.citizenshipCard'
                )}
              />
              <MenuItem
                value={'Drivers License'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.driversLicense'
                )}
              />
              <MenuItem
                value={'Federal ID Card'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.federalIdCard'
                )}
              />
              <MenuItem
                value={'Military ID Card'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.militaryIdCard'
                )}
              />
              <MenuItem
                value={'Passport'}
                primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.passport')}
              />
              <MenuItem
                value={'State/Provincial ID Card'}
                primaryText={getTranslatedString(
                  'landlordPortal.addDocumentOfProofs.stateProvincialIdCard'
                )}
              />

              {/** apparently grouping these together in a react fragment breaks the formatting, so they are done individually */}
              {featureEnabled('ui.applications_page.show_id_types') && (
                <MenuItem
                  value={'Permanent Resident Card'}
                  primaryText={getTranslatedString(
                    'landlordPortal.addDocumentOfProofs.permanentResidentCard'
                  )}
                />
              )}
              {featureEnabled('ui.applications_page.show_id_types') && (
                <MenuItem
                  value={'Work Permit'}
                  primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.workPermit')}
                />
              )}
              {featureEnabled('ui.applications_page.show_id_types') && (
                <MenuItem
                  value={'Student ID'}
                  primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.studentId')}
                />
              )}

              <MenuItem
                value={'Other'}
                primaryText={getTranslatedString('landlordPortal.addDocumentOfProofs.other')}
              />
            </Field>
            <Field name={'idProofType'} component={RenderGhostError} />
          </div>
          <div className="col-md-12">
            <Field
              name="proofOfId"
              component={ReduxDropzone}
              style={{
                border: `1px dashed ${colors.LIGHT_GRAY}`,
                width: '40%',
                margin: 'auto',
                textAlign: 'center',
              }}
              size={100}
              maxFileSize={15000000}
              fileValidation=".jpeg, .png, .jpg, application/pdf"
              labelText={getTranslatedString('landlordPortal.addDocumentOfProofs.clickToAddFile')}
            />
            <Field name={'proofOfId'} component={RenderGhostError} />
          </div>
        </div>
      </div>
    );
  }
}

export default AddDocumentOfProofs;
